import React, {useMemo, useRef} from 'react';
import {Box} from '@mui/material';
import {
  convertPlatformToIcon,
  convertToSlug,
  handleFilterTags,
  handleRenderPriceHomePageMashThead,
  handleReturnCurrency,
  handleReturnIDVideo,
  handleReturnTypeVideo,
  handleReturnVideoDirectly,
} from '~/utils';
import RenderNextImage from '../../atoms/render-next-image';
import {PLACEHOLDER_IMG} from '~/constants';
import dynamic from 'next/dynamic';
import {handleReturnLocaleStore} from '../home-page-mash-thead/home-page-mash-thead';
const GameDetailMasthead = dynamic(
  () => import('@wearesection/bandai-react-components/organisms/GameDetailMasthead')
);

const adapter = (data: any) => {
  const isLocalDisableBtnBuy = false;
  // ['ko-kr'].includes((data?.locale as string)?.toLowerCase());
  const bcProductReference = data?.bcProductReference;
  const BCNameGame = bcProductReference?.title || '';
  return {
    mastheadTitle: data?.mastheadTitle ?? '',
    mastheadBgAsset: data?.mastheadBgAsset ?? '',
    mastheadBgEmbed: handleReturnVideoDirectly(data?.mediaFile as string)
      ? data?.mediaFile
      : handleReturnIDVideo(data?.mastheadBgEmbed as string) || '',
    // mastheadBgEmbed: handleReturnIDVideo(data?.mastheadBgEmbed as string),
    videoType: handleReturnTypeVideo(data?.mastheadBgEmbed as string),
    mastheadDesc: data?.mastheadDesc ?? '',
    fromPricing:
      `${data.locale}`.toLowerCase() === 'ko-kr'
        ? ''
        : BCNameGame
        ? data?.dataTranslation['product-from']
        : '',
    locale: data?.locale?.toLocaleLowerCase() ?? '',
    platforms:
      handleFilterTags(data?.platforms as [])?.map((item: any) => {
        return React.createElement(convertPlatformToIcon(item));
      }) || [],
    ipPublisher: data?.ipPublisher ?? '',
    price: bcProductReference?.price
      ? `${
          `${data.locale}`.toLowerCase() !== 'ko-kr' ? handleReturnCurrency(data?.locale) : ''
        }${handleRenderPriceHomePageMashThead(bcProductReference?.price, data?.locale)}${
          `${data.locale}`.toLowerCase() === 'ko-kr'
            ? `${handleReturnCurrency(data?.locale)} 부터`
            : ''
        }`
      : '',
    currency: '',
    // BCNameGame ? handleReturnCurrency(data?.locale) :
    externalLink: isLocalDisableBtnBuy
      ? ''
      : BCNameGame
      ? `${process.env.NEXT_PUBLIC_STORE_SITE_URL}${handleReturnLocaleStore(
          data?.locale || ''
        )}/store/games/${convertToSlug(BCNameGame)}`
      : undefined,
    ctaButtonText: BCNameGame
      ? bcProductReference?.isPreOrder
        ? data?.dataTranslation['estore-home-page-title-button']
        : data?.dataTranslation['product-buy']
      : undefined,
    trailers: data?.trailers ?? [],
    ctaButtonTrailer: data?.dataTranslation?.['game-detailed-watch-trailer'] || '',
    videoDirectly: handleReturnVideoDirectly(data?.mediaFile as string) ?? false,
    //TODO: Need to remove this hack, it should be Watch Trailer
    isComingSoon: undefined,
    // data?.isComingSoon ?? data?.ctaButtonText === '觀看影片' ? {label: '購買'} : undefined,
    mainImageNext: (
      <RenderNextImage
        src={data?.mastheadBgAsset ?? PLACEHOLDER_IMG}
        width={1920}
        height={1080}
        alt={data?.mastheadTitle || ''}
      />
    ),
  };
};

const GameDetailMastheadOrganisms = (props: any) => {
  const otherSlugs = useRef<any>({});
  const componentProps = useMemo(() => adapter(props), [props]);

  const orderGames = props?.orderGames?.items?.[0] || {};
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const otherLanguagesCollection = orderGames?.otherLanguagesCollection?.items ?? [];

  const defaultValue = orderGames?.languagesPage || '';
  const dataLang = useMemo(() => {
    const newOtherSlugs: any = {};
    if (!otherLanguagesCollection?.length) {
      return [];
    }
    const data = otherLanguagesCollection.map((item: any) => {
      newOtherSlugs[item?.languagesPage] = item?.slug || '';
      return {
        label: item?.languagesPage,
        value: item?.languagesPage,
      };
    });
    otherSlugs.current = newOtherSlugs;
    return data;
  }, [otherLanguagesCollection]);

  const handleChangeLang = (value: any) => {
    const slug = otherSlugs.current[value?.target?.value];
    if (slug) {
      window.location.href = `/games/${slug}`;
      return;
    }
  };

  /**
   * use to hide NavigationBar when the popup slider of GameDetailMasthead appears
   * @param bool
   */
  const hideNavibar = (bool: boolean) => {
    if (typeof window !== 'undefined') {
      const navigation = document.querySelector<HTMLElement>('.navigationBar');
      if (bool && navigation) {
        navigation.style.display = 'none';
      }
      if (!bool && navigation) {
        navigation.style.display = 'block';
      }
    }
  };

  return (
    <Box
      sx={{
        // '& > div': {
        //   height: '124vh',
        // },
        '& < div': {
          padding: '0px',
        },
      }}
    >
      <GameDetailMasthead
        {...componentProps}
        hideNavibar={hideNavibar as any}
        languageSlug={{
          data: dataLang,
          error: false,
          width: 120,
          variant: 'standard',
          disabled: false,
          helperText: 'Helper text',
          defaultValue: defaultValue,
        }}
        onClickDropdownLang={handleChangeLang}
      />
    </Box>
  );
};

export default GameDetailMastheadOrganisms;
